import React from 'react';
import icon from "../../assets/icon.png";

const Header = ({ title,subtitle,description}) => {
  return (
    <div className='flex justify-center items-center w-full flex-col gap-[1rem] text-center'>
          <div className="flex gap-[5px] ">
                    <img
                      src={icon}
                      alt=""
                      className="w-[24px]  h-[24px] object-contain"
                    />
                    <p className="text-[18px] font-Quicksand text-white">
                      {subtitle}
                    </p>
                  </div>
                   <h1 className="text-[55px] leading-tight font-bold  text-gradient ">
                    {title}
                  </h1>
                  <p className="text-[18px] font-Outfit text-white text-center w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%]">
                    {description}
                  </p>
    </div>
  )
}

export default Header
